export const courses = [
  "Đào tạo nội bộ",
  "Đào tạo IOSA",
  "Đào tạo ban đầu",
  "Đào tạo bổ sung năng định",
  "Đào tạo định kỳ",
  "Đào tạo bổ sung kiến thức",
  "Đào tạo phục hồi",
  "Đào tạo khác",
];

export const courseOptions = courses.map((e) => ({ label: e, value: e }));
